import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShoppingGuidePage from "../pages/shopping-guide/page";
import HowToUsePage from "../pages/articles/HowToUsePage";
import TemplatesPage from "../pages/articles/TemplatesPage";
import TipsPage from "../pages/articles/TipsPage";
import FeaturesPage from "../pages/articles/FeaturesPage";
import WorkflowPage from "../pages/articles/WorkflowPage";
import BuildPage from "../pages/articles/BuildPage";
import MistakesPage from "../pages/articles/MistakesPage";
import AlternativesPage from "../pages/articles/AlternativesPage";
import FAQArticlePage from "../pages/articles/FAQArticlePage";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/what-is-litbuy-spreadsheet", element: <ArticlePage /> },
  { path: "/shopping-guide", element: <ShoppingGuidePage /> },
  { path: "/how-to-use-litbuy-spreadsheet", element: <HowToUsePage /> },
  { path: "/litbuy-spreadsheet-templates", element: <TemplatesPage /> },
  { path: "/litbuy-spreadsheet-tips", element: <TipsPage /> },
  { path: "/litbuy-spreadsheet-features", element: <FeaturesPage /> },
  { path: "/litbuy-spreadsheet-workflow", element: <WorkflowPage /> },
  { path: "/build-litbuy-spreadsheet", element: <BuildPage /> },
  { path: "/litbuy-spreadsheet-mistakes", element: <MistakesPage /> },
  { path: "/litbuy-spreadsheet-vs-alternatives", element: <AlternativesPage /> },
  { path: "/litbuy-spreadsheet-faq", element: <FAQArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;